// its middlewear to handle reducer call to update a state

import { postData } from "../../../backend/api";

const fetchVehicle = (data) => {
  // console.log("data",data)
  return (dispatch) => {
    dispatch({
      type: "FETCH_VEHICLE_LOADING",
    });
    postData(data, "validate")
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: "FETCH_VEHICLE_SUCCESS",
            payload: response.data,
          });
        } else {
          dispatch({
            type: "FETCH_VEHICLE_ERROR",
            payload: "validationFailed",
          });
        }
      })
      .catch((error) => {
        // console.log("response catch");
        dispatch({
          type: "FETCH_VEHICLE_ERROR",
          payload: "validationFailed",
        });
      });
  };
};
const clearVehicle = () => {
  return (dispatch) => {
    dispatch({
      type: "CLEAR_VEHICLE",
    });
  };
};
export { fetchVehicle, clearVehicle };

